
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/geographies",
      function () {
        return require("private-next-pages/geographies/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/geographies"])
      });
    }
  